import { Drawer, Form, Input, Select, message } from "antd";
import React, { useState } from "react";
import SapaButton from "../../../ui/Button/Button";
import ProgressLoader from "../../Loader/ProgressLoader";

const AdministratorsModal = ({ onClose, onCreate, open }) => {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const handleSubmit = async (values) => {
    if (typeof onCreate !== "function") {
      message.error("Administrator creation is not available.");
      return;
    }

    setIsSubmitting(true);
    try {
      await onCreate(values);
      handleClose();
    } catch (error) {
      message.error(error?.response?.data?.message || "Unable to create administrator.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ProgressLoader isLoading={isSubmitting}>
      <Drawer
        title="New Admin"
        placement="right"
        onClose={handleClose}
        open={open}
        width={420}
      >
        <Form
          className="administrators-modal"
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <div className="administrators-modal-container">
            <Form.Item
              label="First Name"
              name="first_name"
              rules={[{ required: true, message: "Enter the first name." }]}
            >
              <Input placeholder="First name" disabled={isSubmitting} />
            </Form.Item>
            <Form.Item
              label="Last Name"
              name="last_name"
              rules={[{ required: true, message: "Enter the last name." }]}
            >
              <Input placeholder="Last name" disabled={isSubmitting} />
            </Form.Item>
            <Form.Item
              label="Email Address"
              name="email"
              rules={[
                { required: true, message: "Enter the email address." },
                { type: "email", message: "Enter a valid email address." },
              ]}
            >
              <Input placeholder="admin@nendax.com" disabled={isSubmitting} />
            </Form.Item>
            <Form.Item label="Phone Number" name="phone_number">
              <Input placeholder="+234..." disabled={isSubmitting} />
            </Form.Item>
            <Form.Item
              label="Role"
              name="role"
              initialValue="admin"
              rules={[{ required: true, message: "Select a role." }]}
            >
              <Select
                disabled={isSubmitting}
                options={[
                  { label: "Admin", value: "admin" },
                  { label: "Manager", value: "manager" },
                  { label: "Operations", value: "operations" },
                  { label: "Support", value: "support" },
                ]}
              />
            </Form.Item>
            <Form.Item
              label="Temporary Password"
              name="password"
              rules={[
                { required: true, message: "Enter a temporary password." },
                { min: 8, message: "Use at least 8 characters." },
              ]}
            >
              <Input.Password placeholder="Temporary password" disabled={isSubmitting} />
            </Form.Item>
          </div>
          <div className="administrators-modal-btn__container">
            <SapaButton
              label={"Create admin"}
              shape="rounded"
              buttonType="primary"
              htmlType="submit"
              loading={isSubmitting}
              disabled={isSubmitting}
            />
            <SapaButton
              label={"Cancel"}
              shape="rounded"
              buttonType="transparent"
              onClick={handleClose}
              disabled={isSubmitting}
            />
          </div>
        </Form>
      </Drawer>
    </ProgressLoader>
  );
};

export default AdministratorsModal;
